import React, { useState, useEffect } from "react";
import Sidenavbar from "../Sidenavbar";
import Topbar from "../Topbar";
import "../../styles/CommonStyle.scss";
import "../../styles/Meetings.scss";
import ReactPaginate from "react-paginate";
import { baseURL } from "../BaseUrl";
import { travelizeAuth } from "../HeaderAuthentication";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import AccessDenied from "../../AccessDenied";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { MiClearButton } from "../SbButtons/SbCancelBtn";
import OnScrollLoading, { handleScroll } from "../OnScrollLoading";
import Footer from "../Footer";
import * as swal from "../Consturl/SwalAlert";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MiCustomBtn } from "../SbButtons/SbAddBtn";
import { useDispatch, useSelector } from "react-redux";
import { loadSubsrDropdown } from "../../redux/action";

function KilometerRefreshPage() {
  let userDetails = JSON.parse(sessionStorage.getItem("usdtls"));
  let subscriptionId = JSON.parse(
    sessionStorage.getItem("usrlgndtls")
  ).subscriptionId;

  let dispatch = useDispatch();

  const { subCrDropdown } = useSelector((state) => state.data);

  const [menuCollapse, setMenuCollapse] = useState(false);
  const [filterUserId, setFilterUserId] = useState("");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [manager, setManager] = useState("");
  const [userList, setUserList] = useState([]);
  const [meetingsData, setMeetingsData] = useState([]);
  const [toggleshift, setToggleshift] = useState({ style: "" });
  const [selectAllCheck, setSelectAllCheck] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Lazy Loading
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);

  const toggleMenu = () => {
    if (menuCollapse) {
      setMenuCollapse(false);
      setToggleshift({ style: "" });
    } else {
      setMenuCollapse(true);
      setToggleshift({ style: "toggle-shift-left" });
    }
  };

  // PAGINATION START
  const [PageSize, setPageSize] = useState(20);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };
  // PAGINATION END

  const [subType, setSubType] = useState(0);

  // Open Filter div
  const [filter, setFilter] = useState(false);
  // Open Filter div

  const setSelectSearchDrop = (dates) => {
    const [start, end] = dates;
    setFromDate(start);
    setToDate(end);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchDropdownData();
  }, [subType]);

  useEffect(() => {
    dispatch(loadSubsrDropdown(0));
  }, []);

  const fetchDropdownData = () => {
    let requestOptionZone = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(
      `${baseURL}/api/Subscription/BindUsersDropDown?SubscriptionId=${subType}`,
      requestOptionZone
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setUserList(
            res.result.map((data) => {
              return { value: data.userId, label: data.userFullName };
            })
          );
        } else {
          setUserList([]);
        }
      });
  };

  useEffect(() => {
    {
      fromDate && toDate && getMeetings();
    }
  }, [
    PageSize,
    currentPage,
    subType,
    filterUserId,
    fromDate,
    toDate,
    subscriptionId,
  ]);

  // GET MEETINGS PAGE START
  const getMeetings = () => {
    let requestOption = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(
      `${baseURL}/api/SupportTeam/GetAllMeetingWith0KM?SubscriptionID=${subType}&PageSize=${PageSize}&CurrentPage=${currentPage}&UserId=${filterUserId}&FromDate=${moment(
        fromDate
      ).format("DD/MM/YYYY")}&ToDate=${moment(toDate).format("DD/MM/YYYY")}`,
      requestOption
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setMeetingsData(res.result);
          setPageCount(Math.ceil(res.recordCount[0] / PageSize));
          res.result.forEach((element) => {
            element.inputState = {
              chkSelectRefresh: false,
              meetingID: "String",
              startLocLatitude: 0,
              startLocLongitude: 0,
              startLocLocation: 0,
              endLocLocLatitude: 0,
              endLocLocLongitude: 0,
              endLocLocLocation: 0,
            };
            setTotalData(res.recordCount[0]);
            setIsLoading(false);
            setLoading(false);
          });
        } else {
          setMeetingsData("");
          setIsLoading(false);
          setLoading(false);
        }
        setSelectAllCheck(false);
      });
  };
  // GET MEETINGS PAGE END

  const setMeetingIdforRefresh = (state, meetingID) => {
    if (meetingID !== 0) {
      if (meetingsData.length > 0) {
        let refreshKm = meetingsData.filter((x) => x.meetingID == meetingID);
        if (refreshKm.length > 0) {
          refreshKm[0].inputState.chkSelectRefresh = state;
          refreshKm[0].inputState.meetingID = refreshKm[0].meetingID;
          refreshKm[0].inputState.startLocLatitude =
            refreshKm[0].startLoc.latitude;
          refreshKm[0].inputState.startLocLongitude =
            refreshKm[0].startLoc.longitude;
          refreshKm[0].inputState.startLocLocation =
            refreshKm[0].startLoc.location;
          refreshKm[0].inputState.endLocLocLatitude =
            refreshKm[0].endLoc.latitude;
          refreshKm[0].inputState.endLocLocLongitude =
            refreshKm[0].endLoc.longitude;
          refreshKm[0].inputState.endLocLocLocation =
            refreshKm[0].endLoc.location;
        }
      }
    } else {
      meetingsData.forEach((data) => {
        data.inputState.chkSelectRefresh = state;
        data.inputState.meetingID = data.meetingID;
        data.inputState.startLocLatitude = data.startLoc.latitude;
        data.inputState.startLocLongitude = data.startLoc.longitude;
        data.inputState.startLocLocation = data.startLoc.location;
        data.inputState.endLocLocLatitude = data.endLoc.latitude;
        data.inputState.endLocLocLongitude = data.endLoc.longitude;
        data.inputState.endLocLocLocation = data.endLoc.location;
      });
    }
    setSelectAllCheck(
      meetingsData.every((data) => data.inputState.chkSelectRefresh == true)
    );
    setMeetingsData([...meetingsData]);
  };

  const postRefreshKiloMeters = (e) => {
    e.preventDefault();
    if (meetingsData.length !== 0) {
      let singleRefreshData = meetingsData.filter(
        (data) => data.inputState.chkSelectRefresh == true
      );
      if (singleRefreshData.length === 1) {
        let refreshData = [
          {
            meetingID: singleRefreshData[0].inputState.meetingID,
            attendanceID: "",
            startLoc: {
              latitude: singleRefreshData[0].inputState.startLocLatitude,
              longitude: singleRefreshData[0].inputState.startLocLongitude,
              location: singleRefreshData[0].inputState.startLocLocation,
            },
            endLoc: {
              latitude: singleRefreshData[0].inputState.endLocLocLatitude,
              longitude: singleRefreshData[0].inputState.endLocLocLongitude,
              location: singleRefreshData[0].inputState.endLocLocLocation,
            },
          },
        ];

        let requestOption = {
          method: "POST",
          mode: "cors",
          headers: travelizeAuth,
          body: JSON.stringify(refreshData),
        };
        fetch(
          `${baseURL}/api/SupportTeam/UpdateKmMeetingsAttandance`,
          requestOption
        )
          .then((res) => res.json())
          .then((res) => {
            if (res.success) {
              swal.showAlert("Success", `${res.message}`, "success");
              getMeetings();
            } else {
              toast.error(res.errorMessage, { autoClose: 5000 });
            }
          });
      } else {
        let refreshData = [];
        for (let i = 0; i < singleRefreshData.length; i++) {
          refreshData.push({
            meetingID: singleRefreshData[i].inputState.meetingID,
            attendanceID: "",
            startLoc: {
              latitude: singleRefreshData[i].inputState.startLocLatitude,
              longitude: singleRefreshData[i].inputState.startLocLongitude,
              location: singleRefreshData[i].inputState.startLocLocation,
            },
            endLoc: {
              latitude: singleRefreshData[i].inputState.endLocLocLatitude,
              longitude: singleRefreshData[i].inputState.endLocLocLongitude,
              location: singleRefreshData[i].inputState.endLocLocLocation,
            },
          });
        }

        let requestOption = {
          method: "POST",
          mode: "cors",
          headers: travelizeAuth,
          body: JSON.stringify(refreshData),
        };
        fetch(
          `${baseURL}/api/SupportTeam/UpdateKmMeetingsAttandance`,
          requestOption
        )
          .then((res) => res.json())
          .then((res) => {
            if (res.success) {
              swal.showAlert("Success", `${res.message}`, "success");
            } else {
              toast.error(res.errorMessage, { autoClose: 5000 });
            }
          });
      }
    }
  };

  const clearSerachBySelect = () => {
    setSubType(0);
    setFilterUserId("");
    setManager("");
    setFromDate(new Date());
    setToDate(new Date());
  };

  // Page navigation
  const Navigate = useNavigate();
  const goToBackPage = () => {
    Navigate(-1);
  };
  // page navigation

  return (
    <div id="main-page">
      {userDetails !== null && userDetails !== "" ? (
        <>
          {/* SIDEBAR START */}
          <Sidenavbar menuCollapse={menuCollapse} toggleshift={toggleshift} />
          {/* SIDEBAR END */}

          {/* TOPBAR START */}
          <Topbar
            toggleMenu={toggleMenu}
            menuCollapse={menuCollapse}
            toggleshift={toggleshift}
          />
          {/* TOPBAR END */}

          {/* MAIN BODY START */}
          <div className="page-wrapper">
            {/* PAGE CONTENT START */}
            <div className={`main-body ${toggleshift.style}`}>
              <div className="page-content">
                {/* Filter and Header Section */}
                <div className="user-table">
                  <Row className="search-row">
                    <Col md={5} sm={5} xs={12} className="cat-col">
                      <div className="page-header-text-div">
                        <div className="back-btn" onClick={goToBackPage}>
                          <img
                            src="../../../../images/DefaultImages/back-btn-arrow.svg"
                            alt=""
                          />
                        </div>
                        <h6 className="page-header-text">
                          KM REFRESH (MEETINGS)
                        </h6>
                      </div>
                    </Col>
                    <Col md={7} sm={7} xs={12} className="cat-col">
                      <div
                        className="search-bar-header"
                        style={{ float: "right" }}
                      >
                        <div className="page-top-bar-dropdowns page-top-Filters">
                          <MiCustomBtn
                            btnColor={"primary"}
                            onClickEffect={postRefreshKiloMeters}
                            iconName={"fa fa-refresh"}
                            btnName={"Update Km's"}
                          />
                          <div
                            className="header-filter-btn"
                            onClick={() => setFilter(!filter)}
                          >
                            <div className="filter-icon-text">
                              <i className="bi bi-sliders" />
                              <span>Filters</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  {filter && (
                    <div className="page-filter-section">
                      <div className="filter-row-input-boxes">
                        <div>
                          <Select
                            className="react-select-container-list"
                            classNamePrefix="react-select-list"
                            options={subCrDropdown}
                            placeholder="Select Company"
                            value={subType === 0 ? "" : subCrDropdown.value}
                            onInputChange={subCrDropdown.label}
                            onChange={(data) => setSubType(data.value)}
                            isSearchable={true}
                          />
                        </div>
                        <div>
                          <Select
                            className="react-select-container-list"
                            classNamePrefix="react-select-list"
                            options={userList}
                            placeholder="Select User"
                            // value={userList.value}
                            value={filterUserId === "" ? "" : userList.value}
                            onInputChange={userList.label}
                            onChange={(data) => setFilterUserId(data.value)}
                            isSearchable={true}
                            // isClearable={true}
                          />
                        </div>
                        <div className="from-to-date-select">
                          <div className="input-group-text" id="from-label">
                            From - To
                          </div>
                          <div className="date-picker-with-icon">
                            <DatePicker
                              selected={fromDate}
                              className="select from-date date-filter"
                              id="date-range-picker"
                              dateFormat="dd/MM/yyyy"
                              selectsRange
                              startDate={fromDate}
                              endDate={toDate}
                              onChange={(date) => setSelectSearchDrop(date)}
                              maxDate={new Date()}
                            />
                            <div>
                              <i
                                className="fa fa-calendar-o calander-icon"
                                style={{ right: "6px" }}
                              />
                            </div>
                          </div>
                        </div>
                        <MiClearButton
                          onClickEffect={clearSerachBySelect}
                          btnName="Clear"
                        />
                      </div>
                    </div>
                  )}
                </div>
                {/* Filter and Header Section */}

                {/* USER TABLE START */}
                <div className="meetings-table">
                  <div
                    className="table-responsive meetings-scrollbar"
                    onScroll={(e) =>
                      handleScroll(
                        e,
                        meetingsData,
                        totalData,
                        setLoading,
                        setPageSize,
                        PageSize
                      )
                    }
                  >
                    <table className="table meetings-list-table">
                      <thead className="thead-light meetings-list-thead">
                        <tr>
                          <th>
                            <div className="select-all-check-box-text">
                              {meetingsData.length > 0 && (
                                <>
                                  <input
                                    className="select-all-checkbox"
                                    type="checkbox"
                                    value=""
                                    id="0"
                                    onClick={(e) => {
                                      setMeetingIdforRefresh(
                                        e.target.checked,
                                        0
                                      );
                                    }}
                                    checked={selectAllCheck}
                                  />
                                  <span>Select All </span>
                                </>
                              )}
                              <span style={{ paddingLeft: "15px" }}>NAME </span>
                            </div>
                          </th>
                          <th>MOBILE</th>
                          <th>DATE</th>
                          <th>FROM</th>
                          <th>TO</th>
                          <th>DISTANCE</th>
                        </tr>
                      </thead>
                      <tbody>
                        {meetingsData.length > 0 ? (
                          meetingsData.map((data, i) => (
                            <tr className="meeting-list-row-data" key={i}>
                              <td>
                                <span className="meeting-list-name d-flex">
                                  <input
                                    className="select-single-checkbox"
                                    type="checkbox"
                                    value=""
                                    id={data?.meetingID}
                                    onClick={(e) => {
                                      setMeetingIdforRefresh(
                                        e.target.checked,
                                        data?.meetingID
                                      );
                                    }}
                                    checked={data?.inputState?.chkSelectRefresh}
                                  />

                                  <h6>{data?.fullName}</h6>
                                </span>
                              </td>
                              <td>{data?.contact}</td>
                              <td>{data?.meetingDate}</td>
                              <td style={{ maxWidth: "200px" }}>
                                {data?.startLoc?.location}
                                <span className="client-meet-location">
                                  <p className="client-meet-lat">
                                    <i className="bi bi-geo-alt" />
                                    {data?.startLoc?.latitude},
                                    {data?.startLoc?.longitude}
                                  </p>
                                </span>
                              </td>
                              <td style={{ maxWidth: "200px" }}>
                                {data?.endLoc?.location}
                                <span className="client-meet-location">
                                  <p className="client-meet-lat">
                                    <i className="bi bi-geo-alt" />
                                    {data?.endLoc?.latitude},
                                    {data?.endLoc?.longitude}
                                  </p>
                                </span>
                              </td>
                              <td>{data?.distanceTravelled}</td>
                            </tr>
                          ))
                        ) : (
                          <h6 className="no-data-found">
                            ------ NO DATA FOUND ------
                          </h6>
                        )}
                        {loading && <OnScrollLoading />}
                      </tbody>
                    </table>
                  </div>
                  <div className="download-and-pagination">
                    <span className="user-pagination">
                      <ReactPaginate
                        breakLabel="..."
                        nextLabel={<i className="fa fa-angle-double-right" />}
                        onPageChange={handlePageClick}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={2}
                        pageCount={pageCount}
                        previousLabel={
                          <i className="fa fa-angle-double-left" />
                        }
                        renderOnZeroPageCount={null}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        disabledClassName={"disabled"}
                      />
                    </span>
                  </div>
                </div>
                {/* USER TABLE END */}

                {/* PAGE CONTENT END*/}
              </div>
            </div>

            {/* MAIN BODY END */}
          </div>
          <Footer />
        </>
      ) : (
        <AccessDenied />
      )}
    </div>
  );
}

export default KilometerRefreshPage;
